import React, { useEffect, useState } from 'react';
import InternalBanner from './InternalBanner';
import SkelotonEffect from './SkelotonEffect';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import LazyLoad from 'react-lazyload';
import axios from 'axios';

export default function Gallery() {


    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [images, setImages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);



    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/galleryImages`, {
                    headers: {
                        'Authorization': apiKey,
                        accept: 'application/json',
                    }
                });

                const apiImages = response.data.data.map((img) => ({
                    src: img.image_url,
                    //thumbnail: img.thumbnail_url || img.image_url, 
                    caption: img.event_name,
                    date: img.date,

                }));

                console.log(apiImages);


                setImages(apiImages);
                setIsLoading(false);

            } catch (error) {
                setError(error.message);
                setIsLoading(false);
            }
        };

        fetchData();
    }, [baseURL, apiKey]);

    const handleClick = (index) => {
        setCurrentIndex(index);
        setIsOpen(true);
    };



    return (
        <>
            <InternalBanner title="Gallery" />


            {error ? (
                <section className="error-part">
                    <div className="container">
                        <h1 className='mb-4 d-none'>{error.message}</h1>
                        <img className="img-fluid mb-3" src="assets/images/error.png" alt="error" />

                    </div>
                </section>

            ) : isLoading ? (
                <SkelotonEffect />
            ) : (
                <>
                    <section className="gallery">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-12 my-4">
                                    <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 row-cols-xl-4">
                                        {images.map((image, index) => (
                                            <div key={index} className="thumb tab">
                                                <div onClick={() => handleClick(index)}>
                                                    <LazyLoad height={200} offset={100} once>
                                                        <div className="thumbnail effect effect-one">
                                                            <img
                                                                className="w-100"
                                                                src={image.src}
                                                                alt={image.caption}
                                                            />
                                                            <div className="tab-text">
                                                                <h2>{image.date}</h2>
                                                                <p>{image.caption}</p>
                                                            </div>
                                                        </div>
                                                    </LazyLoad>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Lightbox for modal-like image display */}
                        {isOpen && (
                            <Lightbox
                                open={isOpen}
                                close={() => setIsOpen(false)}
                                slides={images.map(img => ({ src: img.src, title: img.caption }))}
                                index={currentIndex}
                                onIndexChange={setCurrentIndex}
                            />
                        )}
                    </section>
                    <section className='grid_gallery d-none'>
                        <div className='container'>
                            <div className='grid-row'>
                                <div className='box-gallery row_4'>
                                    <img src='assets/images/elements/book_reading.jpg' className='w-100' alt='holding-image' />
                                </div>
                                <div className='box-gallery col_2'>
                                    <img src='assets/images/elements/book_reading.jpg' className='w-100' alt='holding-image' />
                                </div>
                                <div className='box-gallery row_2'>
                                    <img src='assets/images/elements/book_reading.jpg' className='w-100' alt='holding-image' />
                                </div>
                                <div className='box-gallery row_2'>
                                    <img src='assets/images/elements/book_reading.jpg' className='w-100' alt='holding-image' />
                                </div>
                                <div className='box-gallery row_3'>
                                    <img src='assets/images/elements/book_reading.jpg' className='w-100' alt='holding-image' />
                                </div>
                                <div className='box-gallery row_3'>
                                    <img src='assets/images/elements/book_reading.jpg' className='w-100' alt='holding-image' />
                                </div>
                                <div className='box-gallery row_2'>
                                    <img src='assets/images/elements/book_reading.jpg' className='w-100' alt='holding-image' />
                                </div>
                                <div className='box-gallery '>
                                    <img src='assets/images/elements/book_reading.jpg' className='w-100' alt='holding-image' />
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
        </>
    );
}
